const servicesModel = vm => ({
  title: vm.$gettext('Services'),
  endpoint: 'services',
  allowNew: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      required: true,
      sortable: true,
      editable: true,
      description: vm.$gettext('The name may only contain letters, numbers, and dashes.')
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      sortable: true,
      editable: true,
      description: vm.$gettext('The human readable Service name.')
    }
  ],
  filters: ['id', 'name', 'description']
})

export default servicesModel
